//axio api

import api from "@/lib/Api";

export const getAllWorkLocation = async (setting = {}) => {
  try {
    const queryRoute = `/work/getAllWorkLocation`;

    const reqBody = {
      setting: setting,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updatedWorkLocationManage = async (record) => {
  try {
    const queryRoute = `/work/updatedWorkLocationManage`;

    const reqBody = { ...record };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAllStreet = async (setting) => {
  try {
    const queryRoute = `/work/streets`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getWorkLocation = async (id) => {
  try {
    const queryRoute = `/work/${id}`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getWorkExist = async (year) => {
  try {
    const queryRoute = `/work/getWorkExist`;

    const reqBody = {
      searchYear: year,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const importWorkLocation = async (datetime, data) => {
  try {
    const queryRoute = `/work/importWorkLocation`;

    const reqBody = {
      datetime: datetime,
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const editWorkLocation = async (datetime, data) => {
  try {
    const queryRoute = `/work/editWorkLocation`;

    const reqBody = {
      datetime: datetime,
      data: data,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const deleteWorkLocationRecord = async (datetime) => {
  try {
    const queryRoute = `/work/deleteWorkLocationRecord`;

    const reqBody = {
      datetime: datetime,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createWorkLocation = async (record) => {
  try {
    const queryRoute = `/work/createWorkLocation`;

    const reqBody = { ...record };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getRosterTemplate = async (date) => {
  try {
    const queryRoute = `/work/getRosterTemplate/${date}`;

    const fetchRes = api.axios.post(queryRoute, undefined, {
      responseType: "blob",
    });

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getRegionOptions = async (date) => {
  try {
    const queryRoute = `/work/getRegionOptions/`;

    const fetchRes = api.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAddresDetails = async (addName) => {
  try {
    const queryRoute = `/work/getAddressDetails`;
    const reqBody = { addName };
    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
